import * as React from "react";
import {DateInput, required} from "react-admin";

const minDate = (min) => (value) => {
    if (!value) return undefined;
    const v = value instanceof Date ? value : new Date(value);
    v.setHours(0, 0, 0, 0);
    return min > v ? "Phải chọn ngày lớn hơn hôm nay" : undefined;
};

export const CancelToDateInput = (props) => {
    const tomorrowDate = React.useMemo(() => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);

    const validate = React.useMemo(
        () => [required(), minDate(tomorrowDate)],
        [tomorrowDate]
    );

    return (
        <DateInput
            source="cancelToDate"
            validate={validate}
            {...props}
        />
    );
};
